import React from 'react';
import { UserExperienceDto } from '@apply/api/src/api/ApplyApi';
import { VerifiedCount } from './components/VerifiedCount';
import { AddExperienceButton } from './components/AddExperienceButton';
import { isMobileScreen } from '@apply/ui';

export interface ExperienceHeaderProps {
    verifiedExperience: UserExperienceDto[];
}

export const ExperienceHeader: React.FC<ExperienceHeaderProps> = ({ verifiedExperience }) => {
    const mobileScreen = isMobileScreen();
    return (
        <>
            <div className={`experience-header ${mobileScreen ? 'mobile' : ''}`}>
                <VerifiedCount verifiedExperience={verifiedExperience} />
                <div className='experience-header-action'>
                    <AddExperienceButton />
                </div>
            </div>
        </>
    );
};
